import logo from "../../assets/images/transparentlogo.png";
import { COPYRIGHT_TEXT } from "../../Utils/constants";

const LandingPageFooter = () => {

  return (
    <>
      <footer className="footer pb-0">
  <div className="container">
    <div className="row align-items-start">
      <div className="col-md-9 d-flex">
        <div>
          <img src={logo} alt="SkyAzul company logo" />
          <p className="footer-company-desc mb-0">
            SkyAzúl Equipment Solutions is a proven leader in the sales and
            service of monitoring systems for construction and mining
            equipment.
          </p>
        </div>
      </div>
      <div className="col-md-3 ms-md-auto text-md-end mt-3 mt-md-0">
        <label className="c__label">CONTACT US</label>
        <address>
          16 Walnut Street, Middletown,<br />
          Maryland 21769 <br />
          (301) 371-6126 <br />
          info@skyazul.com
        </address>
      </div>
    </div>
  </div>

  <div className="sub-footer">
    <div className="container d-flex">
      <p className="footer-company-desc mb-0 mt-0">
        {COPYRIGHT_TEXT}
      </p>
    </div>
  </div>
</footer>
    </>
  );
};

export default LandingPageFooter;
